<template>
  <!-- 应付单管理 -->
  <div>
    <app-page>
      <template #fheader>
        <div class="fan-search margin-bottom-8">
          <jr-search2
            ref="searchForm"
            :form-list="formList"
            :search-value.sync="queryForm"
            :loading="loading"
            trackCode='paymentPayableList-1'
            @search="handleSearch"
            @reset="handleReset"
          >
            <template slot="batch-search-btn">
              <el-button
                type="primary"
                :size="formSize"
                :loading="loading"
                @click="handleBatchSearch()"
              >
                批量查询
              </el-button>
            </template>
          </jr-search2>
        </div>
      </template>
      <template #header>
        <div class="fan-search">
          <page-select-groups :search-value.sync="queryForm" @change="refreshList" :selectList="selectList" />
          <!-- 导出报表按钮 -->
          <div class="fan-search-col fan-search-right">
            <!-- 表格数据配置 -->
            <jr-columns-config
              :columnsKey="columnsKey"
              :tableColumn="tableColumn"
              :selectTableColumn="selectTableColumn"
              :recommendedColumn="recommendedColumn"
              @confirm="handleConfirm"
            />
            <template v-if="$has('FWS-SFKGL-YFD-DC')">
              <page-export-button
                title="应付单报表导出"
                exportServe="fin_payment_payableReport"
                button-text="导出"
                :total="total"
                :isLimit="true"
                :exportParams="exportParams"
                trackCode="paymentPayableList-3"
              />
            </template>
          </div>
        </div>
      </template>
      <template #main="{ height }">
        <jr-table
          :height="height"
          :key="height"
          :loading="loading"
          :tableData="list"
          :tableColumn="selectTableColumn"
          ref="paymentPayableListRef"
        >
          <template v-slot:orderNumber="{row}">
            <jr-tooltip :content="row.orderNumber || '-'" type="popover" :is-filter="true" />
          </template>
        </jr-table>
      </template>

      <template #ffooter>
        <pagination
          :total="total"
          :current-page="queryForm.page"
          :size="queryForm.limit"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </template>
    </app-page>
    <!-- 详情 -->
    <detail
      :visible.sync="isDetailShow"
      :payable-no.sync="payableNo"
    />
    <!-- 批量搜索 -->
    <batch-search
      :visible.sync="isBatchSearchShow"
      :type-list="batchSearchTypeList"
      :searchType="queryForm.searchType"
      :loading="loading"
      @confirm="handleBatchSearchConfirm"
      trackCode="paymentPayableList-2"
    />
  </div>
</template>

<script>
import { getPaymentPayableList } from '@/api/receivables';
import detail from '../components/payment-payable-detail';
import { setStatusColor } from '@/filters/index';
import { getMonthDate } from '@/utils/date';

const queryFormDefault = {
  beginTime: '', // 开始时间
  endTime: '', // 结束时间
  page: 1,
  limit: 20,
  searchContent: '', // 搜索值
  searchType: '1',
  status: '', // 应付单状态 1 待核销 2 已核销 -1 已取消
  type: '', // 应付单类型： 2、采购商退款 1、供应商付款
  transType: 2, // 订单交易类型1=自营2=服务商
  timeType: '1',
};

export default {
  name: 'paymentPayableList',
  components: { detail },
  data() {
    const list = [
      {
        value: '1',
        label: '业务订单编号',
      }, {
        value: '3',
        label: '应付单编号',
      },
      {
        value: '5',
        label: '客户名称',
      }, {
        value: '6',
        label: '付款申请人',
      },
    ];
    return {
      loading: false,
      sourceProps: {
        value: 'categoryNum',
        label: 'categoryName',
      },
      queryForm: JSON.parse(JSON.stringify(queryFormDefault)),
      list: [],
      total: 0,
      formList: [
        {
          prop: 'timeType',
          component: 'select-date-picker',
          options: [
            { label: '创建时间', value: '1' },
          ],
        },
        {
          prop: 'searchType',
          contentProp: 'searchContent',
          component: 'search-input-select',
          attrs: {
            type: 'text',
            placeholder: '请输入内容',
          },
          options: [...list],
        },
      ],
      isDetailShow: false, // 详情弹窗
      payableNo: '', // 收款单编号
      /** ------批量搜索---- */
      batchSearchTypeList: [ // 批量搜索搜索条件集合
        ...list,
      ],
      isBatchSearchShow: false, // 批量搜索
      tableColumn: [
        {
          prop: 'payableNo',
          label: '应付单编号',
          minWidth: '1',
          permission: 'FWS-SFKGL-YFD-XQ',
          disabled: true,
          trackCode: 'paymentPayableList-4',
          click: (row) => {
            this.handleDetail(row);
          },
        },
        { prop: 'orderNumber', label: '业务订单编号', minWidth: '1', slotName: 'orderNumber' },
        { prop: 'typeDesc', label: '应付单类型', minWidth: '1' },
        { prop: 'businessName', label: '客户名称', minWidth: '1' },
        { prop: 'shouldPayAmount', label: '应付金额(元)', minWidth: '1', filterName: 'toFenThousandsAndFloat', disabled: true },
        { prop: 'realPayAmount', label: '实付金额(元)', minWidth: '1', filterName: 'toFenThousandsAndFloat', disabled: true },
        { prop: 'refundAmount', label: '已退金额(元)', minWidth: '1', filterName: 'toFenThousandsAndFloat', disabled: true },
        { prop: 'crtime', label: '创建时间', minWidth: '1', filterName: 'formatTime', disabled: true },
        { prop: 'cruser', label: '付款申请人', minWidth: '1' },
        {
          label: '状态',
          prop: 'status',
          status: 'status',
          statusDesc: 'statusDesc',
          disabled: true,
          statusColor: (val) => setStatusColor(val, 'cancelStatus'),
        },
      ],
      sourceList: [], // 归属业务
      columnsKey: 'fwsPaymentPayableList',
      selectTableColumn: [],
      recommendedColumn: [
        { prop: 'bdName', label: '业务BD', minWidth: '1' },
      ],
      selectList: [
        {
          title: '应付类型',
          prop: 'type',
          dictionaryPath: '/finance/finance-payment/FinPayableTypeEnum',
        },
        {
          title: '应付单状态',
          prop: 'status',
          dictionaryPath: '/finance/finance-payment/FinPayableStatusEnum',
        },
      ],
    };
  },
  computed: {
    exportParams() {
      const params = {
        ...this.queryForm,
        sourceList: this.sourceList,
      };
      delete params.page;
      delete params.limit;
      return params;
    },
  },
  created() {
    this.resetDate();
    this.init();
  },
  methods: {
    async init() {
      try {
        const list = await this.$store.dispatch('dictionary/getUserTemplate', {
          pageKeys: [this.columnsKey],
          columnsKey: this.columnsKey,
          tableColumn: this.tableColumn,
          recommendedColumn: this.recommendedColumn,
        });
        this.selectTableColumn = list;
      } catch (error) {
        this.selectTableColumn = this.tableColumn;
      }
      this.getList();
    },
    // 配置确认
    handleConfirm(values) {
      this.selectTableColumn = values;
      this.$nextTick(() => {
        this.$refs.paymentPayableListRef.doLayout();
      });
    },
    // 批量查询提交
    handleBatchSearchConfirm(form) {
      const param = { ...queryFormDefault };
      param.searchType = form.searchType || '';
      param.searchContent = (form.list || []).join(',');
      this.queryForm = { ...param };
      this.getList();
    },
    // 批量查询弹窗
    handleBatchSearch() {
      this.isBatchSearchShow = true;
    },
    // 详情
    handleDetail(row) {
      this.payableNo = row?.payableNo || '';
      this.isDetailShow = true;
    },

    // 分页操作
    handleCurrentChange(page) {
      this.queryForm.page = page;
      this.getList();
    },
    handleSizeChange(limit) {
      this.queryForm.page = 1;
      this.queryForm.limit = limit;
      this.getList();
    },
    // 列表查询
    handleSearch(params = {}) {
      this.queryForm = { ...this.queryForm, ...params, page: 1 };
      this.getList();
    },
    // 列表查询
    async getList() {
      const { searchContent, type, status } = this.queryForm;
      if (!this.queryForm.beginTime && !(searchContent || type || status)) {
        this.resetDate();
      }
      try {
        this.loading = true;
        const params = {
          ...this.queryForm,
          sourceList: this.sourceList,
        };
        delete params.timeType;
        const res = await getPaymentPayableList(params);
        this.total = res.totalCount ?? 0;
        this.list = res.data || [];
        this.isBatchSearchShow = false; // 批量搜索弹窗关闭
      } catch (error) {
        console.log(error);
        this.total = 0;
        this.list = [];
      } finally {
        this.loading = false;
      }
    },
    resetDate() {
      const { startDate, endDate } = getMonthDate();
      this.queryForm.beginTime = startDate || '';
      this.queryForm.endTime = endDate || '';
    },
    // 重置搜索条件
    handleReset() {
      this.queryForm = JSON.parse(JSON.stringify(queryFormDefault));
      this.sourceList = [];
      this.resetDate();
      this.$nextTick(() => {
        this.getList();
      });
    },
    refreshList() {
      this.queryForm.page = 1;
      this.getList();
    },
    sourceChange(list) {
      this.sourceList = [...list];
      this.refreshList();
    },
  },
};
</script>
